import * as React from 'react';

interface BreadcrumbDividerProps {}

const BreadcrumbDivider: React.SFC<BreadcrumbDividerProps> = () => (
  <span style={{ fontSize: '0.8em' }}>/</span>
);

export default BreadcrumbDivider;
